module.exports = __webpack_public_path__ + "img/40420fa.png";